
import { FC, useContext, useEffect, useState } from "react";
import ReactInputMask from "react-input-mask";
import DatePicker from "react-datepicker";

import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastTypes } from "src/types";
import { ToastContext } from "src/context/toastContext";

import { RequestDateOfTreatmentProps } from "./types";





const RequestDateOfTreatment: FC<RequestDateOfTreatmentProps> = ({ isModalVisible, caseId, hideModal, prescriptionId, refreshListing }): JSX.Element => {
  const [treatmentDate, changeTreatmentDate] = useState<Date | null>(new Date());
  const [isInvalid] = useState<boolean>(false);

  const { showToast } = useContext(ToastContext);
  // const { destroySession } = useContext(AuthContext);
  // const navigate = useNavigate();

  const resetAndhideModal = () => {
    changeTreatmentDate(null);
    hideModal();
  };





  // const { data: requestTreatmentData, mutate: updateRequestTreatment, error: treatmentUpdateError } =
  //   useFetch<RequestTreatmentNotTreatingApiResponse>(APIEndpoints.REQUEST_TREATMENT_NOT_TREATING);

  // const submitForm = (event: React.FormEvent<HTMLFormElement>) => {
  //   event.preventDefault();

  //   if (treatmentDate) {
  //     setInvalidStatus(false);
  //     const requestBody = {
  //       prescription: {
  //         bentype: "med",
  //         scheduled_date_of_service: treatmentDate
  //       }
  //     }
  //     const queryParam = {
  //       buy_and_bill: true
  //     }
  //     updateRequestTreatment(requestBody, { caseId, prescriptionId }, queryParam);
  //   } else if (treatmentDate === '') {
  //     setInvalidStatus(true);
  //   }
  // }

  // useEffect(() => {
  //   if (treatmentUpdateError) {
  //     resetAndhideModal()
  //   }
  //   if (requestTreatmentData) {
  //     const { code } = requestTreatmentData;
  //     if (code === 200) {
  //       showToast([`Request Treatment Scheduled Successfully`], ToastTypes.SUCCESS);
  //       refreshListing()
  //       resetAndhideModal()
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [requestTreatmentData, treatmentUpdateError]);


  const { data: transferRxData, mutate: transferRxByCaseId } =
    useFetch(APIEndpoints.TRANSFER_RX);

useEffect(() => {
  if (transferRxData) {
    const { message } = transferRxData as unknown as { code: number; message: string; };
    showToast([message], ToastTypes.SUCCESS);
    hideModal()
    refreshListing()
    //getCaseListing();
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [transferRxData]);

// useEffect(() => {
//   if (transferRxLoading) 
//     // setLoader();
//  // else hideLoader();
//   // eslint-disable-next-line react-hooks/exhaustive-deps
// }, [transferRxLoading]);

  const ConfirmAlert = (caseID:number) => {
    
    const result:boolean = window.confirm('Are you sure you want to release this prescription to the specialty pharmacy for processing?');
    // console.log("ConfirmAlert...",result)
    if (result) {
      const queryParam = {
        active: 1,
      }
      console.log("ConfirmAlert...",result)
      transferRxByCaseId({}, { case_id: caseID }, queryParam)
    }
  };



  return (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''}`}
      id="exampleModal"
      tabIndex={-1}
      data-bs-backdrop="true"
      aria-hidden="true"
      onClick={resetAndhideModal}
    >
      <div className="modal-dialog modal-lg" onClick={e => e.stopPropagation()}>
   
          <div className="modal-content">
            <div className="modal-header align-items-start justify-content-between">
              <h1 className="modal-title">
                The FUROSCIX Prescription is Coverage and Copay Only: Do Not Contact Patient {caseId}
              </h1>
              <button type="button" className="btn-close m-0" aria-label="Close" onClick={hideModal}></button>
            </div>

            <div className="modal-body">
              <p className="text-center">By clicking the Rx Transfer button, I approve FUROSCIX Direct to release the
                prescription. The patient has been notified and is expecting a call from FUROSCIX Direct and/or the
                dispensing Pharmacy.
              </p>

              <div className="row align-items-center">


                <div className="col-lg-6 col-12 position-relative">
                  <DatePicker
                      selected={treatmentDate}
                      onChange={(date) => changeTreatmentDate(date)}
                      dateFormat="MM/dd/yyyy" // Altered line
                      className={`form-control ${isInvalid ? "is-invalid" : ""}`}
                      placeholderText="mm/dd/yyyy" // Altered line
                      showMonthDropdown
                      showYearDropdown
                      customInput={
                        <ReactInputMask mask="99/99/9999">
                          {(inputProps: {}) => <input {...inputProps} />}
                        </ReactInputMask>
                      }
                      maxDate={new Date()} // Restrict future dates
                      wrapperClassName="w-100"
                  />
                  <i
                      className="bi bi-calendar position-absolute"
                      style={{
                        right: "20px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                      }}
                  ></i>
                  {/*{isInvalid ? (*/}
                  {/*    <div className="invalid-feedback">*/}
                  {/*      Please select a date first*/}
                  {/*    </div>*/}
                  {/*) : null}*/}
                </div>
                <div className="col-lg-6 col-12">
                  <button
                      className="btn btn-success m-1 text-white"
                      onClick={() => {
                        ConfirmAlert(caseId)
                      }}
                  >
                    <i className="fas fa-prescription"></i> Release Rx, Transfer to Pharmacy
                  </button>
                </div>
              </div>
            </div>


          </div>

      </div>
    </div>
  );
};

export default RequestDateOfTreatment;
